export default __webpack_public_path__ + "static/media/learn2.fefe4b8e.jpg";